import Backbone from 'backbone';
import template from './template.pug';

export class ProgressView extends Backbone.View {
  initialize({
    scope,
    i18n,
  }) {
    this.i18n = i18n;
    this.scope = scope;
  }
  get events() {
    return {
      'click .closebtn': 'close',
    };
  }
  close() {
    this.trigger('close');
  }
  render() {
    const { i18n, scope } = this;
    this.$el.html(template({
      i18n,
      scope,
    }));
    return this;
  }
}
